export enum FolderColorNames {
    cranberry = "cranberry",
    peach = "peach",
    gold = "gold",
    bronze = "bronze",
    lime = "lime",
    dark_green = "dark_green",
    light_teal = "light_teal",
    dark_teal = "dark_teal",
    light_blue = "light_blue",
    dark_blue = "dark_blue",
    lavender = "lavender",
    dark_purple = "dark_purple",
    pink = "pink",
    magenta = "magenta",
    silver = "silver"
}
